import React from 'react';
import PropTypes from 'prop-types';

import { ViewWrapperDefaultGrid } from '@xingternal/platform-layout-view-wrapper';

import { ZenViewGridLess } from './ZenViewGridLess';
import { ZenViewSubHeader } from './ZenViewSubHeader';

const ZenView = ({ backLink, children, ...props }) => {
  return (
    <ZenViewGridLess {...props}>
      <ViewWrapperDefaultGrid>
        {!props.withSubNav && <ZenViewSubHeader backLink={backLink} />}
        {children}
      </ViewWrapperDefaultGrid>
    </ZenViewGridLess>
  );
};

ZenView.displayName = 'ZenView';
ZenView.propTypes = {
  backLink: PropTypes.shape({
    label: PropTypes.string,
    onClose: PropTypes.func,
    to: PropTypes.string,
  }),
  subHeader: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  helpLink: PropTypes.string,
  testId: PropTypes.string,
  withSubNav: PropTypes.bool,
};

export { ZenView };
